var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1527 10.888L19.1077 10.8879C19.6253 10.888 20.0436 10.4697 20.0435 9.95211C20.0435 9.43466 19.6252 9.01634 19.1077 9.01634L11.1525 9.01633L11.1527 1.06126C11.1525 0.543688 10.7343 0.125485 10.2169 0.125485C9.69931 0.125364 9.28099 0.543688 9.28111 1.06126L9.28099 9.01633L1.32592 9.01645C0.808343 9.01633 0.390019 9.43466 0.390139 9.95223C0.390019 10.2102 0.494721 10.4446 0.664135 10.614C0.833549 10.7834 1.0678 10.888 1.32592 10.888L9.28099 10.8879L9.28099 18.8431C9.28099 19.1012 9.38557 19.3354 9.55498 19.5049C9.7244 19.6743 9.95865 19.7789 10.2168 19.7789C10.7343 19.779 11.1527 19.3607 11.1525 18.8431L11.1527 10.888Z",
    fill: "#35435E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.2d50e05aabec70424956635f0f3117bd.svg";
export { ForwardRef as ReactComponent };